"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonDutyFeature = exports.DUTIES_NL = exports.Duty = void 0;
var Duty;
(function (Duty) {
    // Direct
    Duty["VirtualVisit"] = "virtualVisit";
    // Simpel
    Duty["Visit"] = "visit";
    Duty["Cashback"] = "cashback";
    // Compleet
    Duty["Energiepaspoort"] = "energiepaspoort";
    Duty["EnergyLabel"] = "energyLabel";
    // Other
    Duty["FullElectricAdvice"] = "fullElectricAdvice";
    Duty["EnergyIndex"] = "energyIndex";
    Duty["NomAdvice"] = "nomAdvice";
    Duty["Subsidy"] = "subsidy";
    Duty["Taxation"] = "taxation";
    // Promos
    Duty["QuoteDiscount"] = "quoteDiscount";
})(Duty = exports.Duty || (exports.Duty = {}));
exports.DUTIES_NL = {
    [Duty.Cashback]: 'Cashback',
    [Duty.Energiepaspoort]: 'Energiepaspoort™',
    [Duty.EnergyIndex]: 'Energie-index',
    [Duty.EnergyLabel]: 'Energielabel',
    [Duty.FullElectricAdvice]: 'Elektrische warmtepomp advies',
    [Duty.NomAdvice]: 'NOM-advies',
    [Duty.QuoteDiscount]: 'Korting op offertes',
    [Duty.Subsidy]: 'Subsidie',
    [Duty.VirtualVisit]: 'Virtuele opname',
    [Duty.Visit]: 'Fysieke opname',
    [Duty.Taxation]: 'Taxatie',
};
var NonDutyFeature;
(function (NonDutyFeature) {
    NonDutyFeature["Advice"] = "advice";
    NonDutyFeature["Quotes"] = "quotes";
    NonDutyFeature["Coordination"] = "coordination";
    NonDutyFeature["Invoicing"] = "invoicing";
    NonDutyFeature["Warranty"] = "warranty";
    NonDutyFeature["Updates"] = "updates";
    NonDutyFeature["UnlimitedMoves"] = "unlimitedMoves";
    NonDutyFeature["EnergyLabelSupplementary"] = "energyLabelSupplementary";
    NonDutyFeature["EnergyLabelAdvice"] = "energyLabelAdvice";
    NonDutyFeature["CurrentLabelRegistration"] = "currentLabelRegistration";
    NonDutyFeature["ImprovedLabelRegistration"] = "improvedLabelRegistration";
    NonDutyFeature["Aftercare"] = "aftercare";
})(NonDutyFeature = exports.NonDutyFeature || (exports.NonDutyFeature = {}));
